function isEndOrHostAddress (endAddress, hostAddress) {
//   console.log(endAddress, hostAddress)
  let flag = true
  if (endAddress == hostAddress) {
    flag = false
  }
  return flag
}
export {
  isEndOrHostAddress
}
